import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { LazyLoadEvent } from 'primeng/components/common/api';
import { Postcode } from '../models/postcode';
import { PostcodesService } from './services/postcodes.service';
import { URLSearchParams, Response } from '@angular/http';
import { Paginated } from '../models/paginated';
import { MessageService } from 'primeng/components/common/messageservice';

@Component({
	selector: 'app-postcodes',
	templateUrl: './postcodes.component.html'
})
export class PostcodesComponent implements OnInit
{
	@Input() showButton: boolean;
	@Input() shouldHideButtonForRecord: Function;
	@Input() buttonIconClass: string;

	@Output() postcodeClicked = new EventEmitter();

	public limit: number;
	public data: Paginated<Postcode[]>;

	constructor(private postcodesService: PostcodesService, private messageService: MessageService)
	{
		this.limit = 8;
		this.data = new Paginated<Postcode[]>();
	}

	ngOnInit()
	{
		if (typeof this.buttonIconClass === 'undefined')
		{
			this.buttonIconClass = 'fa-search';
		}
	}

	shouldHideButton(postcode: Postcode): boolean
	{
		if (typeof this.shouldHideButtonForRecord !== 'undefined')
		{
			return this.shouldHideButtonForRecord(postcode);
		}

		return !this.showButton;
	}

	updatePostcodesList(event: LazyLoadEvent)
	{
		const search = new URLSearchParams();
		search.set('page', (event.first / this.limit + 1).toString());
		search.set('limit', this.limit.toString());

		if ('postcode' in event.filters)
		{
			search.set('search_postcode', event.filters['postcode'].value);
		}

		if ('city' in event.filters)
		{
			search.set('search_city', event.filters['city'].value);
		}

		if ('description' in event.filters)
		{
			search.set('search_description', event.filters['description'].value);
		}

		if (typeof event.sortField !== 'undefined')
		{
			search.set('sort_field', event.sortField);

			if (event.sortOrder > 0)
			{
				search.set('sort_order', 'desc');
			}
			else
			{
				search.set('sort_order', 'asc');
			}
		}

		this.postcodesService.searchPostcodes(search).then((data: any) =>
		{

			if (data instanceof Response)
			{
				this.data = new Paginated<Postcode[]>();

				this.messageService.add({
					severity: 'error',
					summary: 'Fout',
					detail: 'Er is een fout opgetreden tijdens het ophalen van de postcodes.'
				});
			}
			else
			{
				this.data = data as Paginated<Postcode[]>;
			}

		});
	}

}



// WEBPACK FOOTER //
// ./src/app/postcodes/postcodes.component.ts